import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/logo.png';
import _imports_1 from '@/assets/images/qrcodeWX.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6934de2a"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "Container"
};
var _hoisted_2 = {
  class: "menuContainer max-width"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "logoContainer"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "",
    class: "logo"
  })], -1);
});

var _hoisted_4 = {
  class: "mainMenu"
};
var _hoisted_5 = {
  class: "rows"
};

var _hoisted_6 = /*#__PURE__*/_createTextVNode("产品服务");

var _hoisted_7 = /*#__PURE__*/_createTextVNode("修谱学堂");

var _hoisted_8 = /*#__PURE__*/_createTextVNode("文章资讯");

var _hoisted_9 = /*#__PURE__*/_createTextVNode("下载应用");

var _hoisted_10 = /*#__PURE__*/_createTextVNode("藏谱阁");

var _hoisted_11 = /*#__PURE__*/_createTextVNode("姓氏百科");

var _hoisted_12 = {
  class: "rows"
};

var _hoisted_13 = /*#__PURE__*/_createTextVNode("用户中心");

var _hoisted_14 = /*#__PURE__*/_createTextVNode("用户注册");

var _hoisted_15 = /*#__PURE__*/_createTextVNode("用户登录");

var _hoisted_16 = /*#__PURE__*/_createTextVNode("找回密码");

var _hoisted_17 = /*#__PURE__*/_createTextVNode("联系客服");

var _hoisted_18 = {
  class: "rows"
};

var _hoisted_19 = /*#__PURE__*/_createTextVNode("联系我们");

var _hoisted_20 = /*#__PURE__*/_createTextVNode("业务咨询");

var _hoisted_21 = /*#__PURE__*/_createTextVNode("加盟咨询");

var _hoisted_22 = /*#__PURE__*/_createTextVNode(" 公司地址：浙江省永康市总部中心金族大厦一楼大印家 ");

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("a", {
    href: "https://beian.miit.gov.cn/",
    target: "_blank"
  }, " 浙ICP备17046479号-2 ", -1);
});

var _hoisted_24 = {
  class: "qrCodeContainer"
};

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "image"
  }, null, -1);
});

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, "微信公众号", -1);
});

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    class: "image"
  }, null, -1);
});

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "text"
  }, "大印小程序", -1);
});

export function render(_ctx, _cache) {
  var _component_el_row = _resolveComponent("el-row");

  var _component_el_col = _resolveComponent("el-col");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 7,
        class: "col"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_row, {
            class: "title"
          }, {
            default: _withCtx(function () {
              return [_hoisted_6];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_7];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_8];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_9];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 1
          })])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 7,
        class: "col"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_row, {
            class: "title"
          }, {
            default: _withCtx(function () {
              return [_hoisted_13];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_14];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_15];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_16];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_17];
            }),
            _: 1
          })])];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 10,
        class: "col"
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_row, {
            class: "title"
          }, {
            default: _withCtx(function () {
              return [_hoisted_19];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_20];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_21];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_22];
            }),
            _: 1
          }), _createVNode(_component_el_row, {
            class: "text"
          }, {
            default: _withCtx(function () {
              return [_hoisted_23];
            }),
            _: 1
          })])];
        }),
        _: 1
      })];
    }),
    _: 1
  })]), _createElementVNode("div", _hoisted_24, [_createVNode(_component_el_row, null, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_col, {
        span: 12,
        class: "col"
      }, {
        default: _withCtx(function () {
          return [_hoisted_25, _hoisted_26];
        }),
        _: 1
      }), _createVNode(_component_el_col, {
        span: 12,
        class: "col"
      }, {
        default: _withCtx(function () {
          return [_hoisted_27, _hoisted_28];
        }),
        _: 1
      }), _createVNode(_component_el_col)];
    }),
    _: 1
  })])])]);
}